"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioFieldSchema = exports.default = void 0;
var RadioField_1 = require("./RadioField");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(RadioField_1).default; } });
Object.defineProperty(exports, "radioFieldSchema", { enumerable: true, get: function () { return RadioField_1.radioFieldSchema; } });
//# sourceMappingURL=index.js.map